import { FormActionButton } from '@workwave-tidal/core/form'

import * as OrderTexts from '../../../../intl'
import { form } from '../formState'

type Props = {
  planLocked: boolean
  creating: boolean
  handleCancel: () => void
}

export function Footer(props: Props) {
  const { planLocked, creating, handleCancel } = props

  const {
    meta: { submitting, validating, status },
  } = form.useFormMeta()

  // When creating a new entity the submit button should be enabled also when the form is in a pristine status
  const saveDisabled =
    planLocked || creating
      ? validating || submitting
      : status === 'pristine' || validating || submitting

  return (
    <>
      <FormActionButton
        label={OrderTexts.getCancelText()}
        onClick={handleCancel}
        testId="footer-secondary-button"
        data-trackid="footer-secondary-button"
      />
      <FormActionButton
        label={OrderTexts.getFormSaveText()}
        variant="contained"
        type="submit"
        disabled={saveDisabled}
        loading={submitting || validating}
        testId="footer-primary-button"
        data-trackid="footer-primary-button"
      />
    </>
  )
}
